import IndustryPageTemplate from "./IndustryPageTemplate";
import { interiorDesignersData } from "@/data/interiorDesigners";

export default function InteriorDesignersPage() {
  return <IndustryPageTemplate data={interiorDesignersData} />;
}
